import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { IReducer } from '../../../../../../redux/configureStore';
import Card from '../../../../../../shared/components/Card';
import {
  CardLabel,
  CardValue,
  ContentCard,
  LabelAndValueContainer,
} from '../../../../../../shared/components/Card/components/CardComponents';
import theme from '../../../../../../styles/theme';
import checkValue from '../../../../../../utils/values';
import BarChart from '../components/CardWithBarChart/components/BarChart';
import CardWithTable from '../components/CardWithTable';
import Frame from './components/Frame';
import PdpixPartnersPassedOn from './components/PdfpixPartnersPassedOn';

function PixDashboard() {
  const pixFaresState = useSelector((reducer: IReducer) => reducer.pixFares);
  const faresFilterState = useSelector(
    (reducer: IReducer) => reducer.faresFilter
  );
  const profilePartnerState = useSelector(
    (reducer: IReducer) => reducer.partnerProfile
  );
  const globalIsActive = Object.prototype.hasOwnProperty.call(
    pixFaresState.income.value,
    'Fiducia'
  );

  const hasData = useMemo(() => {
    if (
      pixFaresState.partnerPassedOn.length > 0 &&
      profilePartnerState.nivel === 2
    ) {
      return true;
    }
    return false;
  }, [pixFaresState.partnerPassedOn, profilePartnerState.nivel]);

  function isPartnerGlobalBarChart() {
    if (faresFilterState.searched.partner === 'global') {
      return true;
    }
    return false;
  }

  return (
    <Frame.Base isActive={pixFaresState.isActive}>
      <Card
        isActive
        title="Pix Recebidas"
        display="flex"
        gridArea="pixReceived"
        justifyContent="space-around"
        flexDirection="row"
        height="100%"
        width="100%"
        backgroundColor="#FFFFFF">
        <LabelAndValueContainer alignCenter>
          <CardLabel>Total</CardLabel>
          <CardValue color={theme.colors.emphasis}>
            {checkValue(pixFaresState.pixReceived.value).toLocaleString(
              'pt-br',
              {
                style: 'currency',
                currency: 'BRL',
              }
            )}
          </CardValue>
        </LabelAndValueContainer>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Quantidade</CardLabel>
          <CardValue color={theme.colors.emphasis}>
            {pixFaresState.pixReceived.quantity}
          </CardValue>
        </LabelAndValueContainer>
      </Card>
      <Card
        isActive
        title="Pix Enviadas"
        display="flex"
        gridArea="pixSent"
        justifyContent="space-around"
        flexDirection="row"
        height="100%"
        width="100%"
        backgroundColor="#FFFFFF">
        <LabelAndValueContainer alignCenter>
          <CardLabel>Total</CardLabel>
          <CardValue color={theme.colors.emphasis}>
            {checkValue(pixFaresState.pixSent.value).toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </CardValue>
        </LabelAndValueContainer>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Quantidade</CardLabel>
          <CardValue color={theme.colors.emphasis}>
            {pixFaresState.pixSent.quantity}
          </CardValue>
        </LabelAndValueContainer>
      </Card>
      <Card
        isActive={!globalIsActive}
        title="Tarifas Recebidas"
        display="flex"
        gridArea="faresReceived"
        justifyContent="center"
        flexDirection="row"
        height="100%"
        width="100%"
        backgroundColor="#FFFFFF">
        <LabelAndValueContainer alignCenter>
          <CardLabel>Total</CardLabel>
          <CardValue color={theme.colors.emphasis}>
            {checkValue(pixFaresState.faresReceived.value).toLocaleString(
              'pt-br',
              {
                style: 'currency',
                currency: 'BRL',
              }
            )}
          </CardValue>
          <CardLabel>Quantidade</CardLabel>
          <CardValue color={theme.colors.emphasis}>
            {pixFaresState.faresReceived.quantity}
          </CardValue>
        </LabelAndValueContainer>
      </Card>

      <Card
        isActive={globalIsActive}
        title="Tarifas Recebidas"
        display="flex"
        gridArea="faresReceived"
        justifyContent="space-around"
        flexDirection="row"
        height="100%"
        width="100%"
        backgroundColor="#FFFFFF">
        <LabelAndValueContainer alignCenter>
          <CardLabel>Global</CardLabel>
          <CardValue color={theme.colors.emphasis}>
            {checkValue(pixFaresState.fares.global).toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </CardValue>
        </LabelAndValueContainer>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Fiducia</CardLabel>
          <CardValue color={theme.colors.emphasis}>
            {checkValue(pixFaresState.fares.fiducia).toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </CardValue>
        </LabelAndValueContainer>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Parceiros</CardLabel>
          <CardValue color={theme.colors.emphasis}>
            {checkValue(pixFaresState.fares.partner).toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </CardValue>
        </LabelAndValueContainer>
      </Card>

      <Card
        isActive={!globalIsActive}
        title="Tarifas Repassadas"
        display="flex"
        gridArea="faresPassedOn"
        justifyContent="center"
        flexDirection="row"
        height="100%"
        width="100%"
        backgroundColor="#FFFFFF">
        <LabelAndValueContainer alignCenter>
          <CardLabel>Total</CardLabel>
          <CardValue color={theme.colors.red}>
            {checkValue(pixFaresState.faresPassedOn.value).toLocaleString(
              'pt-br',
              {
                style: 'currency',
                currency: 'BRL',
              }
            )}
          </CardValue>
          <CardLabel>Quantidade</CardLabel>
          <CardValue color={theme.colors.red}>
            {pixFaresState.faresPassedOn.quantity}
          </CardValue>
        </LabelAndValueContainer>
      </Card>

      <Card
        isActive={globalIsActive}
        title="Resultados"
        display="flex"
        gridArea="income"
        justifyContent="space-around"
        flexDirection="row"
        height="100%"
        width="100%"
        backgroundColor="#FFFFFF">
        <LabelAndValueContainer alignCenter>
          <CardLabel>Global</CardLabel>
          <CardValue color={theme.colors.emphasis}>
            {checkValue(
              pixFaresState.income.value.ambiente_382 > 0
                ? pixFaresState.income.value.ambiente_382
                : 0
            ).toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </CardValue>
        </LabelAndValueContainer>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Fiducia</CardLabel>
          <CardValue color={theme.colors.emphasis}>
            {checkValue(
              pixFaresState.income.value.Fiducia > 0
                ? pixFaresState.income.value.Fiducia
                : 0
            ).toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </CardValue>
        </LabelAndValueContainer>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Parceiros</CardLabel>
          <CardValue
            color={
              pixFaresState.income.value.Parceiro >= 0
                ? theme.colors.emphasis
                : theme.colors.red
            }>
            {checkValue(
              pixFaresState.income.value.Parceiro > 0
                ? pixFaresState.income.value.Parceiro
                : 0
            ).toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </CardValue>
        </LabelAndValueContainer>
      </Card>

      <Card
        isActive={!globalIsActive}
        gridArea="income"
        title="Resultado"
        display="flex"
        flexDirection="column"
        justifyContent="flex-start"
        width="100%"
        height="100%"
        backgroundColor="#FFFFFF">
        <ContentCard hasOneData alignCenter justifyCenter>
          <CardLabel>Total</CardLabel>
          <CardValue hasOneData color={theme.colors.emphasis}>
            {checkValue(
              pixFaresState.income.value > 0 ? pixFaresState.income.value : 0
            ).toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </CardValue>
        </ContentCard>
      </Card>

      <CardWithTable
        isActive={hasData}
        gridArea="table"
        title="Repasses de Tarifas"
        subtitle=""
        valueColor="#18A3A8"
        data={pixFaresState.partnerPassedOn}
        pdf={{
          title: 'Tarifas de Pix Repassadas para Parceiros',
          body: <PdpixPartnersPassedOn />,
        }}
      />

      <Card
        isActive={!isPartnerGlobalBarChart()}
        title="Tarifas Movimentadas nos Últimos 12 Meses"
        gridArea="lastTwelveMonths"
        display="flex"
        flexDirection="column"
        justifyContent="flex-start"
        width="100%"
        height="100%"
        backgroundColor="#FFFFFF">
        <BarChart
          data={pixFaresState.lastTwelveMonths}
          hasOneData={false}
          firstValueColor={theme.colors.emphasis}
          secondValueColor={theme.colors.red}
          labelForTwoDatas={{
            firstLabel: `Tarifas recebidas   `,
            secondLabel: 'Tarifas repassadas',
          }}
        />
      </Card>

      <Card
        isActive={isPartnerGlobalBarChart()}
        title="Tarifas Movimentadas nos Últimos 12 Meses"
        gridArea="lastTwelveMonths"
        display="flex"
        flexDirection="column"
        justifyContent="flex-start"
        width="100%"
        height="100%"
        backgroundColor="#FFFFFF">
        <BarChart
          data={pixFaresState.lastTwelveMonths}
          hasOneData={false}
          firstValueColor={theme.colors.emphasis}
          secondValueColor={theme.colors.blue}
          labelForTwoDatas={{
            firstLabel: `Tarifas recebidas (Fidúcia)   `,
            secondLabel: 'Tarifas repassadas (Parceiros)',
          }}
        />
      </Card>
    </Frame.Base>
  );
}

export default PixDashboard;
